import { render, staticRenderFns } from "./Report2AnatomyMap.vue?vue&type=template&id=e4d5f514&scoped=true&"
import script from "./Report2AnatomyMap.vue?vue&type=script&lang=js&"
export * from "./Report2AnatomyMap.vue?vue&type=script&lang=js&"
import style0 from "./Report2AnatomyMap.vue?vue&type=style&index=0&id=e4d5f514&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d5f514",
  null
  
)

export default component.exports